export default [
  {
    path: '*',
    meta: {
      public: true
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true
    },
    name: 'NotFound',
    component: () => import(`@/pages/NotFound.vue`)
  },
  {
    path: '/403',
    meta: {
      public: true
    },
    name: 'AccessDenied',
    component: () => import(`@/pages/Deny.vue`)
  },
  {
    path: '/500',
    meta: {
      public: true
    },
    name: 'ServerError',
    component: () => import(`@/pages/Error.vue`)
  },
  {
    path: '/sharing',
    meta: {
      public: true
    },
    name: 'Sharing',
    component: () => import(`@/pages/Sharing.vue`)
  },
  {
    path: '/login',
    meta: {
      public: true
    },
    name: 'Login',
    component: () => import(`@/pages/Login.vue`)
  },
  {
    path: '/forgotpassword',
    meta: {
      public: true
    },
    name: 'forgotpassword',
    component: () => import(`@/pages/forgotpassword/index.vue`)
  },
  {
    path: '/confirmotp',
    meta: {
      public: true
    },
    name: 'confirmotp',
    component: () => import(`@/pages/forgotpassword/otp.vue`)
  },
  {
    path: '/confirmpassword',
    meta: {
      public: true
    },
    name: 'confirmpassword',
    component: () => import(`@/pages/forgotpassword/ConfirmPassword.vue`)
  },
  {
    path: '/register',
    meta: {
      public: true
    },
    name: 'register',
    component: () => import(`@/pages/register/index.vue`)
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'map'
    }
  },
  {
    path: '/map',
    meta: { breadcrumb: true },
    name: 'map',
    component: () => import(`@/pages/map/index.vue`)
  },
  {
    path: '/geofence',
    meta: { breadcrumb: true },
    name: 'geofence',
    component: () => import(`@/pages/geofence/index.vue`)
  },
  {
    path: '/maintenance',
    meta: { breadcrumb: true },
    name: 'maintenance',
    component: () => import(`@/pages/maintenance/index.vue`)
  },
  {
    path: '/notification',
    meta: { breadcrumb: true },
    name: 'notification',
    component: () => import(`@/pages/notification/index.vue`)
  },
  {
    path: '/news',
    meta: { breadcrumb: true },
    name: 'news',
    component: () => import(`@/pages/notification/news.vue`)
  },
  {
    path: '/reporting/daily',
    meta: { breadcrumb: true },
    name: 'daily',
    component: () => import(`@/pages/reporting/Daily.vue`)
  },
  {
    path: '/reporting/dailybyvehicle',
    meta: { breadcrumb: true },
    name: 'dailyByVehicle',
    component: () => import(`@/pages/reporting/DailyByVehicle.vue`)
  },
  {
    path: '/settings',
    meta: { breadcrumb: true },
    name: 'settings',
    component: () => import(`@/pages/settings/index.vue`)
  },
];



// WEBPACK FOOTER //
// ./src/router/paths.js